import { compose, invoker, replace, toLower } from 'ramda';

export const normalizeStr = (str) => compose(
  replace(/[\u0300-\u036f]/g, ''),
  invoker(1, 'normalize')('NFD'),
  toLower
)(str);
